import { CompanyTitledPage } from "../../TitledPage";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import Button from "@mui/material/Button";

import { useLocation, useNavigate } from "react-router-dom";
import { CompanyPartHeader } from "../../../components/PartHeader";
import useInputObject from "../../../hooks/useInputObject";
import { insertProductDetail } from "../../../http/api/ProductDetailAPI";
import ProductDetailInfo from "../ProductDetailInfo/ProductDetailInfo";
import { useContext, useState } from "react";
import { ScreenStatusContext } from "../../../context/ScreenStatusContext";
import { MSG_CONFIRM_INPUT_CHANGE_NOT_UPDATED } from "../../../common/message";
import { confirmWhenChanged } from "../../../utils/validation";

const infoTableCellSx = {
  fontSize: 18,
};

// 新規商品明細登録ページ
export default function ProductDetailRegisterPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const productId = location.state.productId;
  const productDetail = useInputObject({});

  // 登録中をあらわすstate
  const [isRegistering, setRegistering] = useState(false);
  // 画面ステータスをcontextから取得
  const {isChanged} = useContext(ScreenStatusContext);

  // 登録ボタンをクリック
  const onClickRegister = async (event) => {
    setRegistering(true);

    productDetail.Value.productId = productId;
    productDetail.Value.createdId = 1; //TODO JWTを追加した後削除
    productDetail.Value.updatedId = 1; //TODO JWTを追加した後削除
    
    await insertProductDetail(productDetail.Value);
    alert("商品明細を登録しました。");
    navigate("/company/product", {
      state: getProductDetailLocationState(productId),
    });
  };

  function getProductDetailLocationState(productId) {
    return { productId };
  }
  
  // 戻るボタンをクリック
  const onClickReturn = (event) => {
    if (confirmWhenChanged(isChanged)) {
      navigate(-1);
    }
  };

  return (
    <CompanyTitledPage title="商品明細登録">
      <CompanyPartHeader>
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>
              商品明細の入力
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Button variant="contained" onClick={onClickRegister} disabled={isRegistering}>
              登録
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button variant="outlined" onClick={onClickReturn}>
              戻る
            </Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>

      <ProductDetailInfo productId={productId} productDetail={productDetail} />
    </CompanyTitledPage>
  );
}
